var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-mu",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00a04d",
    d: "M0 360h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151f6d",
    d: "M0 120h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee2737",
    d: "M0 0h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd00",
    d: "M0 240h640v120H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMu);
export default __webpack_public_path__ + "static/media/mu.468d5464.svg";
export { ForwardRef as ReactComponent };